// ENTRAID-350 review L5: the coded deploy failure reasons a customer receives (backend lib/deploy-failure.mjs), in plain
// language. The raw AWS CloudFormation text is never shown to a customer.
export const DEPLOY_FAILURE_TEXT = Object.freeze({
  'permission-denied': 'The onGuard role in your AWS account was not allowed to create one of the resources.',
  'trust-scope-mismatch': 'The onGuard access role in your AWS account is set up for a different collector name. Update it from Settings, AWS deployment.',
  'already-exists': 'A resource with the same name already exists in your AWS account, for example from an earlier install.',
  'limit-exceeded': 'Your AWS account reached a service limit.',
  'stack-not-found': 'The collector stack was removed while it was being created.',
  'code-signing': 'AWS could not verify the signature of the onGuard code.',
  'rolled-back': 'AWS CloudFormation rolled the install back.',
  'stack-failed': 'AWS CloudFormation could not create one of the resources.',
});

/** Plain text for a coded reason; null for no reason; a generic line for an unknown code. */
export function deployFailureText(code) {
  if (code == null || code === '') return null;
  return DEPLOY_FAILURE_TEXT[code] ?? DEPLOY_FAILURE_TEXT['stack-failed'];
}
